// @ts-check
import cybersource from '../../../engines/cybersource';

/**
 * @typedef {Object} CardParams Card parameters
 */

/**
 * Interface for a Cybersource strategy.
 * @typedef {Object} CybersourceStrategy
 * @property {function(CardParams): Promise<Object>} createPayload - Create payment payload.
 */

/**
 * Cybersource strategy
 * @returns {CybersourceStrategy} The Cybersource strategy
 */
const CybersourceStrategy = () => {
  /**
   * Function to create payload for Cybersource
   * @param {Object} cardParams - The card parameters
   * @returns {Promise<Object>} The payload
   */
  const createPayload = (cardParams) => {
    return cybersource.createPayload(cardParams);
  };

  return { createPayload };
};

const cybersourceStrategy = CybersourceStrategy();

export default cybersourceStrategy;
